
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gvl13Q_45owGty4DzORHKsclLjeeumAns9412gDQnJ_GnIMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexmQVpXU4b0nPCZ4tRjMalHiWaMbrUyAfZGCoqQDvRbQYMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchT_45uCFAcKByhsvPXur8nhvEkAjlsrOjt2TSKXjNqHvpsMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexUnrz9fO_ZswoOBkbZ3MfrcmqTTTizqXuCPSB8r9Us3UMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93fKSXfsn9Ubuqa0onA50ixp5e0erMguBerIUJlLtN3L8Meta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexmQkS_45Z20e9jVgsE182SqxzkN0uQCTDSf3gT7BF90LrUMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_933PDtyvcIKhsTWwSJFMYLmPb4uMl8nNRiWqPQubqAAdAMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index8IRL_QOjNCXVXH177LQjuZNSzSzU8L0ZYDCDELEcPS4Meta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93jIYbC4EW7FlQ5ukMP_8Fv6CmisESBSPeMBUKjnNCoikMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexq4fa4Hw7pwl8OAnRpTPm8N8bnEX1NIaVqknGLUJCVkoMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index81xAHdOTxEacijTRXjgHjLjYpJXxJNlOD3UuQZUwvgsMeta } from "/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexmQkS_45Z20e9jVgsE182SqxzkN0uQCTDSf3gT7BF90LrUMeta || {},
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index8IRL_QOjNCXVXH177LQjuZNSzSzU8L0ZYDCDELEcPS4Meta || {},
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexq4fa4Hw7pwl8OAnRpTPm8N8bnEX1NIaVqknGLUJCVkoMeta || {},
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index81xAHdOTxEacijTRXjgHjLjYpJXxJNlOD3UuQZUwvgsMeta || {},
    component: () => import("/codebuild/output/src1173123418/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]